// extracted by mini-css-extract-plugin
export default {"sampleIdsPopover":"SampleUploadIds_sampleIdsPopover__VY7l5"};